(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-product-trust-shipping"] && !Shopify.designMode) return;
  try {
    
  const cleanSeoSupportLinks = () => {
    document.querySelectorAll('a[href*="/customer_authentication/redirect"]').forEach((link) => {
      const wrapper = link.closest('p');
      if (wrapper && wrapper.textContent.toLowerCase().includes('check out faster')) {
        wrapper.remove();
      } else {
        link.removeAttribute('href');
      }
    });

    document.querySelectorAll('iframe[src*="/web-pixels"], iframe[src*="web-pixel"]').forEach((frame) => {
      if (!frame.title) frame.title = 'Shopify analytics pixel';
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
    });
  };

  cleanSeoSupportLinks();

  if ('MutationObserver' in window) {
    new MutationObserver(cleanSeoSupportLinks).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  } catch(e) { console.error(e); }
})();
})();
